module.exports = __webpack_public_path__ + "static/media/Gilmer-Light.c88dd3c0.otf";